import { render } from "./linkedin.vue?vue&type=template&id=8c8e69d8"
const script = {}

import exportComponent from "/usr/local/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__